export enum EMeteoType {
    Sec = 1,
    Pluvieux = 2,
    Brumeux = 3,
    Neigeux = 4,
}